import { combineReducers, Action } from '@ngrx/store';

import { IBackState } from './back.state';
import { BackAuthFeatureKey } from './auth/auth.state';
import { BackAuthReducers } from './auth/auth.reducer';
import { BackMiscFeatureKey } from './misc';
import { BackMiscReducer } from './misc/misc.reducer';
import { BackPrtgReducer } from './prtg/prtg.reducer';
import { BackPrtgFeatureKey } from './prtg/prtg.state';

import { BackPataCopilFeatureKey } from './pata/copils/copils.state';
import { BackPataCopilsReducer } from './pata/copils/copils.reducer';
import { BackEntitiesSelectionReducer } from './entities-selection/entities-selection.reducer';

import { BackItsmFeatureKey } from './itsm/itsm.state';
import { BackItsmReducer } from './itsm/itsm.reducer';
import { BackBckpFeatureKey } from './bckp/bckp.state';

import { BackBckpReducer } from './bckp/bckp.reducer';
import { BackEntitiesSelectionFeatureKey } from './entities-selection/entities-selection.state';

export function BackReducers (state: IBackState | undefined, action: Action)
{
    return combineReducers({
        [BackAuthFeatureKey]: BackAuthReducers,
        [BackMiscFeatureKey]: BackMiscReducer,
        [BackPrtgFeatureKey]: BackPrtgReducer,
        [BackPataCopilFeatureKey]: BackPataCopilsReducer,
        [BackItsmFeatureKey]: BackItsmReducer,
        [BackBckpFeatureKey]: BackBckpReducer,
        [BackEntitiesSelectionFeatureKey]: BackEntitiesSelectionReducer
    })(state, action);
}
